import React from 'react'

const NftSkeletonCard = () => {
  return (
    <div className="w-full">
      <div className="w-full aspect-square rounded-[10px] overflow-hidden">
        <div className="skeletonLoader"></div>
      </div>
      <div className="w-full h-[16px] rounded-[8px] overflow-hidden mt-[15px]">
        <div className="skeletonLoader"></div>
      </div>
      <div className="w-full h-[16px] rounded-[8px] overflow-hidden mt-[8px]">
        <div className="skeletonLoader"></div>
      </div>
      <div className="w-full h-[16px] rounded-[8px] overflow-hidden mt-[8px]">
        <div className="skeletonLoader"></div>
      </div>
      <div className="w-1/2 h-[16px] rounded-[8px] overflow-hidden mt-[8px] mb-[15px]">
        <div className="skeletonLoader"></div>
      </div>
    </div>
  )
}

export default NftSkeletonCard
